import { useMemo } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { FormGrid, FlexWrapper, FormInput } from "components/molecules";
import { IRegisterUserForm } from "services/userManagement/types";
import Dropdown from "components/molecules/dropdown/Dropdown";
import { Input } from "components/atoms";

const UserPermissions = () => {
  const { values, status, setFieldValue } =
    useFormikContext<IRegisterUserForm>();

  const { t } = useTranslation();

  const groupedPermissions = useMemo(() => {
    return Object.keys(values.permissions).reduce((acc, domain) => {
      acc[domain] = values.permissions[domain].permissions;
      return acc;
    }, {} as Record<string, { flag: number; isSelected: boolean }[]>);
  }, [values.permissions]);

  const handleSelectAll = (domain: string, isSelected: boolean) => {
    const updatedPermissions = {
      ...values.permissions,
      [domain]: {
        ...values.permissions[domain],
        permissions: values.permissions[domain].permissions.map((perm) => ({
          ...perm,
          isSelected: isSelected,
        })),
      },
    };

    setFieldValue("permissions", updatedPermissions);
  };

  return (
    <FlexWrapper>
      {Object.keys(groupedPermissions).map((domain) => (
        <Dropdown
          key={domain}
          title={t(`permissions.domains.${domain}`)}
          extraElement={
            <Input.Switch
              label=""
              onChange={(checked) =>
                !checked
                  ? handleSelectAll(domain, false)
                  : handleSelectAll(domain, true)
              }
              checked={
                !!groupedPermissions[domain].find(
                  (permission) => permission.isSelected
                )
              }
              className={`${
                status?.displayMode
                  ? "pointer-events-none"
                  : "pointer-events-auto"
              }`}
            />
          }
        >
          <FormGrid>
            {groupedPermissions[domain].map((permission, index) => (
              <FormInput.Switch
                key={index}
                name={`permissions.${domain}.permissions.${index}.isSelected`}
                label={t(`permissions.${domain}.${permission.flag}`)}
                checked={permission.isSelected}
                className={`${
                  status?.displayMode
                    ? "pointer-events-none"
                    : "pointer-events-auto"
                }`}
              />
            ))}
          </FormGrid>
        </Dropdown>
      ))}
    </FlexWrapper>
  );
};

export default UserPermissions;
